import { __assign } from "tslib";
import * as React from 'react';
var units = {
    byte: {
        c: ['B', 'kB', 'MB', 'GB', 'TB', 'PB'],
        d: 1024,
    },
    weight: {
        c: ['g', 'kg', 't', 'kt', 'Mt', 'Gt'],
        d: 1000,
    },
    abbr: {
        c: ['', 'k', 'M', 'G', 'T', 'P'],
        d: 1000,
    },
    none: {
        c: [],
        d: 1,
    },
};
function getValue(value) {
    if (value < 10) {
        return ~~(value * 10) / 10;
    }
    else {
        return ~~value;
    }
}
function getQuantity(value, unit) {
    var u = units[unit];
    if (!u || u.d === 1) {
        return getValue(value);
    }
    return getSize(value, u.c, u.d);
}
function getCategory(value, divider, maxpow) {
    var i = 0;
    while (value > divider && i < maxpow) {
        value = value / divider;
        i++;
    }
    return [i, value];
}
function getSize(value, categories, divider) {
    var _a = getCategory(value, divider, categories.length - 1), cat = _a[0], val = _a[1];
    var lab = categories[cat];
    return lab ? "".concat(getValue(val)).concat(lab) : getValue(value);
}
export var StatsRow = function (props) { return React.createElement("div", __assign({}, props, { className: "stats-row" })); };
export var StatsValueItem = function (_a) {
    var value = _a.value, _b = _a.unit, unit = _b === void 0 ? 'none' : _b, children = _a.children;
    return (React.createElement("div", { className: "stats-value-item" },
        React.createElement("div", { className: "stats-quantity" }, getQuantity(value, unit)),
        React.createElement("div", { className: "stats-label" }, children)));
};
export var StatsInfoChart = function (_a) {
    var value = _a.value, _b = _a.color, color = _b === void 0 ? '#FFC007' : _b, _c = _a.fill, fill = _c === void 0 ? 100 : _c, children = _a.children;
    return (React.createElement("div", { className: "stats-circle-chart" },
        React.createElement("svg", { viewBox: "0 0 36 36", className: "stats-circle-chart-circle", stroke: color },
            React.createElement("path", { className: "stats-circle-chart-background", d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" }),
            React.createElement("path", { className: "stats-circle-chart-progress", d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831", strokeDasharray: fill }),
            React.createElement("text", { x: "18", y: "20.35", className: "stats-circle-chart-percentage" }, value)),
        React.createElement("p", { className: "stats-circle-chart-title" }, children)));
};
export var StatsCircleChart = function (_a) {
    var value = _a.value, _b = _a.color, color = _b === void 0 ? '#FFC007' : _b, children = _a.children;
    return (React.createElement("div", { className: "stats-circle-chart" },
        React.createElement("svg", { viewBox: "0 0 36 36", className: "stats-circle-chart-circle", stroke: color },
            React.createElement("path", { className: "stats-circle-chart-background", d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" }),
            React.createElement("path", { className: "stats-circle-chart-progress", d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831", strokeDasharray: "".concat(value, ", 100") }),
            React.createElement("text", { x: "18", y: "20.35", className: "stats-circle-chart-percentage" },
                getValue(value),
                "%")),
        React.createElement("p", { className: "stats-circle-chart-title" }, children)));
};
export var Stats = function (props) { return React.createElement("div", __assign({}, props)); };
//# sourceMappingURL=index.js.map